import moment from "moment";

export function isMeetingPast(meeting) {
  if (!meeting?.end_at) {
    return false;
  }

  return moment(meeting.end_at).isSameOrBefore(moment());
}

export function isMeetingJoinable(meeting) {
  if (!meeting?.joinable_until) {
    return true;
  }

  return moment().isBefore(moment(meeting.joinable_until));
}

export function getMeetingGraceLabels(meeting) {
  if (!meeting?.end_at || !meeting?.joinable_until) {
    return { endedLabel: "", expiresLabel: "" };
  }

  return {
    endedLabel: moment(meeting.end_at).fromNow(),
    expiresLabel: moment(meeting.joinable_until).fromNow(),
  };
}

export function formatMeetingDisplayId(displayId) {
  if (!displayId) {
    return "";
  }

  return String(displayId).replace(/(\d{3})(?=\d)/g, "$1 ");
}

export function normalizeDigits(value, maxLength) {
  const digits = String(value || "").replace(/\D/g, "");

  return maxLength ? digits.slice(0, maxLength) : digits;
}
